import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=e35712c2&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editor.vue?vue&type=style&index=1&id=e35712c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35712c2",
  null
  
)

export default component.exports